// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getSchedulerRequest: ['data'],
  getSchedulerSuccess: ['data'],
  getSchedulerFailure: ['err'],

  getSchedulerDetailRequest: ['data'],
  getSchedulerDetailSuccess: ['data'],
  getSchedulerDetailFailure: ['err'],

  postSchedulerRequest: ['data'],
  postSchedulerSuccess: ['data'],
  postSchedulerFailure: ['err'],

  putSchedulerRequest: ['data'],
  putSchedulerSuccess: ['data'],
  putSchedulerFailure: ['err'],

  deleteSchedulerRequest: ['data'],
  deleteSchedulerSuccess: ['data'],
  deleteSchedulerFailure: ['err']
})

export const SchedulerTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  err: null,
  processing: false,
  success: null,
  detail: {}
})

/* ------------- Reducers ------------- */
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: true // important: initial value is null
  })

export const successDetail = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    detail: data,
    err: null,
    success: true
  })

export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_SCHEDULER_SUCCESS]: success,
  [Types.GET_SCHEDULER_REQUEST]: request,
  [Types.GET_SCHEDULER_FAILURE]: failure,

  [Types.GET_SCHEDULER_DETAIL_SUCCESS]: successDetail,
  [Types.GET_SCHEDULER_DETAIL_REQUEST]: request,
  [Types.GET_SCHEDULER_DETAIL_FAILURE]: failure,

  [Types.POST_SCHEDULER_SUCCESS]: manipulateSuccess,
  [Types.POST_SCHEDULER_REQUEST]: manipulateRequest,
  [Types.POST_SCHEDULER_FAILURE]: manipulateFailure,

  [Types.PUT_SCHEDULER_SUCCESS]: manipulateSuccess,
  [Types.PUT_SCHEDULER_REQUEST]: manipulateRequest,
  [Types.PUT_SCHEDULER_FAILURE]: manipulateFailure,

  [Types.DELETE_SCHEDULER_SUCCESS]: manipulateSuccess,
  [Types.DELETE_SCHEDULER_REQUEST]: manipulateRequest,
  [Types.DELETE_SCHEDULER_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/SchedulerRedux.js